export default __webpack_public_path__ + "static/media/telegram.190943b9.svg";